import gql from 'graphql-tag'

export const QUERY_GET_CAMPAIGNS = gql`
  query Campaigns(
    $_ids: [ID]
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [String]
    $sortDirection: [SortDirection]
    $mode: [CampaignModeEnum]
    $franchise: Boolean
    $status: [StatusEnum]
    $isIndustry: Boolean
    $industryIds: [ID]
  ) {
    campaigns(
      _ids: $_ids
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      mode: $mode
      franchise: $franchise
      status: $status
      isIndustry: $isIndustry
      industryIds: $industryIds
    ) {
      records
      page
      campaigns {
        _id
        title
        description
        initial_date
        final_date
        mode
        message {
          send_date
          send_time
          text
        }
        frequency {
          type
        }
        status
        updated_at
        ... on SMSChannelCampaign {
          industry {
            _id
            name
          }
        }
        ... on WhatsappChannelCampaign {
          senders {
            name
            number
          }
          targeting_mode
        }
      }
    }
  }
`

export const QUERY_GET_GENERIC_CAMPAIGNS = gql`
  query GenericCampaigns(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [String]
    $sortDirection: [SortDirection]
    $channels: [ChannelEnum]
    $status: [StatusEnum]
    $frequency: CampaignFrequencyTypeEnum
  ) {
    genericCampaigns(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      channels: $channels
      status: $status
      frequencyType: $frequency
    ) {
      records
      page
      campaigns {
        _id
        title
        description
        initial_date
        final_date
        mode
        status
        updated_at
        campaign_type
        message {
          text
        }
        channels {
          email {
            message {
              send_date
            }
          }
          whatsapp {
            message {
              send_date
            }
          }
          push {
            message {
              send_date
            }
          }
          sms {
            message {
              send_date
            }
          }
        }
      }
    }
  }
`

export const QUERY_GET_GENERIC_CAMPAIGNS_BY_ID = gql`
  query GenericCampaigns($campaignIds: [ID]) {
    genericCampaigns(campaignIds: $campaignIds) {
      records
      page
      campaigns {
        _id
        title
        description
        initial_date
        final_date
        mode
        status
        updated_at
      }
    }
  }
`

export const QUERY_GET_SEGMENTS = gql`
  query Segments($search: String, $page: Int, $pageSize: Int, $sort: [String], $sortDirection: [SortDirection]) {
    segments(search: $search, page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection) {
      records
      page
      segments {
        _id
        name
        description
        version
        clients_qty
        campaign_qty
        data
        created_at
        updated_at
        clients_refreshed_at
      }
    }
  }
`

export const QUERY_GET_MESSAGES_HISTORY = gql`
  query MessagesHistory($id: ID!, $page: Int, $pageSize: Int, $sort: [String], $sortDirection: [SortDirection], $channels: [ChannelEnum]) {
    messagesHistory(_id: $id, page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection, channels: $channels) {
      page
      messages_history {
        client_id
        contact
        content
        status
        price
        date
      }
    }
  }
`

export const QUERY_GET_AGGREGATE_CLIENT_COUNT_BY_CHANNEL = gql`
  query GetAggregatedClientStatusInfo {
    getAggregatedClientStatusInfo {
      push {
        total_count
      }
      email {
        total_count
      }
      sms {
        total_count
      }
      whatsapp {
        total_count
      }
      maria_campaign {
        total_count
      }
      all {
        total_count
      }
    }
  }
`

export const MUTATION_CLONE_CAMPAIGN = gql`
  mutation CloneCampaign($id: ID!) {
    cloneCampaign(_id: $id) {
      _id
    }
  }
`

export const MUTATION_DELETE_CAMPAIGN = gql`
  mutation DeleteCampaign($id: ID!) {
    deleteCampaign(_id: $id) {
      _id
      message
    }
  }
`

export const MUTATION_UNSCHEDULE_CAMPAIGN = gql`
  mutation UnscheduleCampaign($id: ID!) {
    unscheduleCampaign(_id: $id) {
      _id
      message
    }
  }
`

export const MUTATION_CANCEL_WHATSAPP_SENDINGS = gql`
  mutation CancelWhatsappSendings($id: ID!) {
    cancelWhatsappSendings(campaign_id: $id)
  }
`

export const MUTATION_CANCEL_SMS_CAMPAIGN = gql`
  mutation CancelRecurrentSMSCampaign($id: ID!) {
    cancelRecurrentSMSCampaign(_id: $id)
  }
`

export const MUTATION_STATICALLY_CLONE_SEGMENTS = gql`
  mutation StaticallyCloneSegments($segments_ids: [ID!]!, $name: String!, $description: String!) {
    staticallyCloneSegments(segments_ids: $segments_ids, name: $name, description: $description) {
      _id
      name
      description
      campaign_qty
      clients_qty
      clients_qty_at_campaign
      clients_refreshed_at
      fixed
    }
  }
`

export const INDUSTRY_MUTATION_STATICALLY_CLONE_SEGMENTS = gql`
  mutation StaticallyCloneIndustrySegments($segments_ids: [ID!]!, $name: String!, $description: String!, $industryName: String!) {
    staticallyCloneIndustrySegments(segments_ids: $segments_ids, name: $name, description: $description, industryName: $industryName) {
      _id
      name
      fixed
      industry {
        name
      }
      description
      clients_qty
      campaign_qty
      created_at
      clients_refreshed_at
    }
  }
`

export const QUERY_GET_CAMPAIGN_METRICS = gql`
  query Campaign($id: ID!, $units: [String]) {
    campaign(_id: $id) {
      message {
        sendings {
          delivered
          clients
          total
          sent
          price
          credits
          text
          date
          time
        }
      }
      metrics(units: $units) {
        analytic_metrics {
          credits
          sending_credits
          validation_credits
          price
          sending_price
          validation_price
          received_roi
          opened_roi
          average_ticket_received_variation
        }
        clients_metrics {
          sent {
            count
            revenue
            average_ticket
            tickets
          }
          received {
            count
            revenue
            average_ticket
            tickets
          }
          opened {
            count
            revenue
            average_ticket
            tickets
          }
          clicked {
            count
          }
          opened_and_bought {
            count
            revenue
            average_ticket
            tickets
          }
          opened_with_products {
            count
            revenue
            average_ticket
            tickets
          }
          opened_with_only_products {
            count
            revenue
            average_ticket
            tickets
          }
          received_and_bought {
            count
            revenue
            average_ticket
            tickets
          }
          received_with_products {
            count
            revenue
            average_ticket
            tickets
          }
          received_with_only_products {
            count
            revenue
            average_ticket
            tickets
          }
          total {
            revenue
          }
        }
        contacts_metrics {
          validated_quantity
          blacklisted_quantity
        }
        general_metrics {
          general {
            messages_sent
            messages_received
            messages_read
            messages_clicked
          }
        }
        products_metrics {
          totals {
            total {
              quantity
              revenue
            }
            received {
              quantity
              revenue
              tickets
              clients
            }
            opened {
              quantity
              revenue
              tickets
              clients
            }
          }
          table {
            product {
              sku
              name
            }
            total {
              quantity
              revenue
            }
            received {
              quantity
              revenue
              tickets
              clients
            }
            opened {
              quantity
              revenue
              tickets
              clients
            }
          }
        }
      }
    }
  }
`

export const MUTATION_CANCEL_EMAIL_CAMPAIGN = gql`
  mutation CancelRecurrentEmailCampaign($id: ID!) {
    cancelRecurrentEmailCampaign(_id: $id)
  }
`

export const MUTATION_CANCEL_PUSH_CAMPAIGN = gql`
  mutation CancelRecurrentPushCampaign($id: ID!) {
    cancelRecurrentPushCampaign(_id: $id)
  }
`

export const SEND_HISTORY_REPORT = gql`
  mutation CreateCampaignMessageHistoricReport($emails: [String!]!, $campaignId: ID!, $fileFormat: FileFormatType, $channels: [ChannelEnum!]!) {
    createCampaignMessageHistoryReport(emails: $emails, channels: $channels, campaignId: $campaignId, fileFormat: $fileFormat) {
      id
      fileUrl
      state
      payload {
        emails
        campaignId
        fileFormat
        channels
      }
    }
  }
`
